import React, {useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import './index.scss';

import * as Actions from '../../redux/actions';

//components
import Loader from "../../components/common/loader";
import DynamicLink from '../../components/dynamic_link';
import {getMediaPath} from "../../app/functions";

//assets
import board from 'assets/icons/board.svg';
import v_green from 'assets/icons/v-purple.svg';

const JoiningLink = (props) =>{

    const page = useSelector(store => store.data.MailLinkPage);
    const dispatch = useDispatch();

    useEffect(()=>{
        const hash = props.match.params;
        dispatch(Actions.getUsersApplicationApprovalPage(hash));
    }, []);


    const getOptions = () =>{
        const data = page.body;
        let res = [];

        data.forEach((option, index) =>{
            res.push(
                <div key={index} className='option-wrapper'>
                    <h2 className='option-title'>{option.title}</h2>
                    <img className='option-image' src={getMediaPath(option.imagePath)} alt=''/>
                    <DynamicLink className='option-link'  data={option.link}>{option.btn_text}</DynamicLink>

                    <span className='bullets-title'>{option.bullets_title}</span>

                    <div className='bullets-container'>
                        {option.bullets.map((bullet, bul_index) =>{
                            return (
                                <div key={bul_index} className='bullet-wrapper'>
                                    <img src={v_green} alt=''/>
                                    <span>{bullet}</span>
                                </div>
                            )
                        })}
                    </div>
                </div>
            )
        });

        return res;
    };


    return(
        <section className='joining-link'>
            {page &&
            <div className='template-wrapper'>
                <div className='top'>
                    <h2 className='title'>{page.header.page_title}</h2>
                    <img src={board} alt=''/>
                </div>
                <div className='content'>
                    <h3 className='content-title'>{page.header.page_sub_title}</h3>

                    <div className='options-container'>
                        {getOptions()}
                    </div>

                    <div className='small-letters'>
                        {page.footer.text}
                    </div>
                </div>
            </div>
            }
            {!page && <Loader/>}
        </section>
    )
};

export default JoiningLink;
